<ion-header class="fixed-header">
  <div class="app-sub-header">
    <div class="back">
      <ion-icon name="arrow-back-outline"></ion-icon>
    </div>
    <div>
      {{ '_spinning_wheel_setting_title_' | translate }}
    </div>
  </div>
</ion-header>

<ion-content>
  <div style="padding: 20px 0"
       [ngStyle]="{'background-color': backgroundColor, 'color': textColor}">
    <div class="spinning-wheel-preview content-max-width" [class.spun]="hasSpun && prizeImg">

      <div class="coop-image">
        <img [src]="imgUrl" [alt]="imgUrl"/>
      </div>


      <div class="preview-section">

        <ng-container *ngIf="!hasSpun">
          <div class="luck">
            {{ '_try_your_luck_' | translate}}
          </div>
          <div class="wheel-text">
            {{ '_spin_the_wheel_' | translate}}
          </div>
        </ng-container>

        <ng-container *ngIf="hasSpun && spinIndex !== -1 ">
          <div class="luck">
            {{ '_congratulations_' | translate}}
          </div>
          <div class="wheel-text">
            {{prizeTitle }}
          </div>
        </ng-container>

        <ng-container *ngIf="hasSpun && spinIndex === -1 ">
          <div class="luck">
            {{ '_almost_there_' | translate }}
          </div>
          <div class="wheel-text">
            {{ '_luck_next_time_' | translate }}
          </div>
        </ng-container>

        <div style="margin: 25px 0">
          <div *ngIf="!hasSpun || (hasSpun && prizeImg == '')" class="wheel-outer">
            <div class="wheel-container">
              <div
                class="wheel"
                [class.one-prize]="prizeStructures.length === 4"
                [class.two-prize]="prizeStructures.length === 6"
                [class.three-prize]="prizeStructures.length === 8"
                [class.fourth-prize]="prizeStructures.length === 10"
                [ngClass]="{
        'to-cross': hasSpun && !isWin,
        'to-gift': isWin
      }"
                [id]="'wheel'"
                [attr.data-prize-count]="prizeCount"
                [attr.data-spin-id]="spinUuid"
                [attr.data-spun]="hasSpun ? 'yes' : 'no'"
                [attr.data-is-winner]="isWin ? 'yes' : 'no'"
                [style.transform]="'rotate(' + wheelRotation + 'deg)'"
              >
                <div
                  *ngFor="let prize of prizeStructures; let i = index"
                  class="section"
                  [ngClass]="{
          win: prize !== 'lose',
          lose: prize === 'lose'
        }"
                  [style.background]="prize !== 'lose' ? prize.wheel_color : ''"
                >
        <span *ngIf="prize !== 'lose' " [style.color]="prize.text_color">
          {{ prize.name }}
        </span>
                  <span *ngIf="prize === 'lose' " [style.color]="prize.text_color">
           <img src="assets/spinning-wheel/cross.svg">
        </span>
                </div>
              </div>

              <button
                id="spinButton"
                class="btn"
                [ngClass]="{ 'hide-tap': hasSpun }"
                (click)="onSpin()"
              >
                <div class="inner-circle"></div>
              </button>
            </div>
          </div>
          <div
            *ngIf="hasSpun && prizeImg !== ''"
            class="text-center">
            <img
              style="border-radius: 0.5rem"
              src="{{prizeImg}}">
          </div>

          <div id="confetti-container"></div>
        </div>

        <div [ngStyle]="{ 'padding-bottom': isIOS ? '150px' : '0px', 'margin-bottom' : isIOS ? '0px' : '100px' }">
          <app-button
            color="tertiary"
            type="submit"
            expand="block"
            (click)="handleClose()"
          >
            {{ '_close_preview_' | translate}}
          </app-button>
        </div>

      </div>

    </div>
  </div>
</ion-content>


